module.exports = __webpack_public_path__ + "static/media/down.cdee1bd3.svg";